<template>
  <b-modal
    :id="'show-publish-success-url'+slug"
    no-close-on-backdrop
    centered
    size="lg"
  >
    <template #modal-header>
      <h3>{{ $t('modals.showPublishSuccess.title') }}</h3>
    </template>
    <div class="show-url-icon text-center px-2">
      <b-icon icon="check-circle" variant="success" class="mt-4 mb-3"></b-icon>
      <p class="mt-2 mb-3"
           v-html="$t('modals.showPublishSuccess.messageOne', { name: safeName })">
      </p>

      <!-- Clean URL with Copy Button -->
      <div class="mb-3">
        <p class="mb-2"
           v-html="$t('modals.showPublishSuccess.messageTwo', { name: safeName })"></p>
        <div class="url-copy-container d-flex align-items-center justify-content-center mb-3">
          <a class="show-url mr-2" :href="publishingUrl" target="_blank">
            <u>{{ publishingUrl }}</u>
          </a>
          <b-button
            size="sm"
            class="text-dark"
            variant="light"
            @click="copyCleanUrl"
            v-b-tooltip.hover
            :title="$t('buttons.copyLink')"
          >
            <b-icon :icon="cleanUrlCopied ? 'check' : 'clipboard'"></b-icon>
          </b-button>
        </div>
          <!-- UTM Sharing Section -->
      <UtmShareSection
        :publishing-url="publishingUrl"
        :page-type="pageType"
        :slug="slug"
      />
        <!-- QR Code Section -->
        <b-button v-b-toggle.collapse-qr class="m-1 light-grey-button" size="sm">
          {{ $t('modals.qrCode.button') }}
        </b-button>
        <b-collapse id="collapse-qr">
          <div class="pt-3">
            <p><img :src="`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${publishingUrl}`" alt="QR Code"></p>
            <p>
              <a :href="`https://api.qrserver.com/v1/create-qr-code/?format=svg&data=${publishingUrl}&download=1`">{{ $t('modals.qrCode.svg') }}</a>
              <br>
              <a :href="`https://api.qrserver.com/v1/create-qr-code/?size=1000x1000&format=jpg&data=${publishingUrl}&download=1`">{{ $t('modals.qrCode.jpg') }}</a>
            </p>
          </div>
        </b-collapse>
      </div>
    </div>
    <template #modal-footer>
      <b-button
        class="p-3"
        block
        @click="closeModal"
      >
        {{ $t('buttons.ok') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import UtmShareSection from '@/components/modals/UtmShareSection.vue';

export default {
  name: 'ModalShowPublishSuccess',
  components: {
    UtmShareSection,
  },
  props: ['slug', 'groupSlug', 'slugPath', 'pageType', 'groupDomain', 'itemName'],
  data() {
    return {
      publishingUrl: null,
      cleanUrlCopied: false,
      copyTimeout: null,
    };
  },
  computed: {
    // The name lands in v-html, so it must be escaped.
    safeName() {
      const name = this.itemName || this.$t(`webmag.${this.pageType}`);
      return String(name).replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
    },
  },
  created() {
    this.publishingUrl = `${this.groupDomain}${this.slugPath}`;
    if (this.pageType === 'project') {
      this.publishingUrl = `${this.publishingUrl}/`;
    }
  },
  mounted() {
    this.$bvModal.show(`show-publish-success-url${this.slug}`);
  },
  methods: {
    async copyCleanUrl() {
      try {
        await navigator.clipboard.writeText(this.publishingUrl);
        this.cleanUrlCopied = true;

        if (this.copyTimeout) {
          clearTimeout(this.copyTimeout);
        }

        this.copyTimeout = setTimeout(() => {
          this.cleanUrlCopied = false;
        }, 2000);

        this.$bvToast.toast(this.$t('modals.showPublishSuccess.linkCopied'), {
          variant: 'success',
          solid: true,
          autoHideDelay: 2000,
          noCloseButton: true,
        });
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    },
    closeModal() {
      this.$bvModal.hide(`show-publish-success-url${this.slug}`);
      this.$emit('modal-confirmed');
    },
  },
  beforeDestroy() {
    if (this.copyTimeout) {
      clearTimeout(this.copyTimeout);
    }
  },
};
</script>

<style scoped lang="scss">
.show-url-icon svg {
  font-size: 60px;
}
.show-url {
  font-size: 1rem;
  word-break: break-all;
}
.url-copy-container {

  padding: 0.75rem;
  border-radius: 8px;
}
</style>
